var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "header__right d-flex" }, [
    _c("div", { staticClass: "o-userInfo d-flex" }, [
      _c(
        "div",
        { staticClass: "m-userInfo__data align-items-center d-none d-lg-flex" },
        [
          _c("div", { staticClass: "a-userInfo__item" }, [
            _c("span", { staticClass: "__coins" }),
            _vm._v(
              _vm._s(_vm.profil.pouzivatel_id.pouzivatel_wallet) +
                "\n            "
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "a-userInfo__item" }, [
            _c("span", { staticClass: "__banknotes" }),
            _vm._v(
              _vm._s(_vm.profil.pouzivatel_id.pouzivatel_bankovky) +
                "\n            "
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "a-userInfo__item" }, [
            _c("span", { staticClass: "__experience" }, [
              _c("span", { staticClass: "level-number" }, [
                _vm._v(_vm._s(_vm.profil.pouzivatel_id.level_id))
              ])
            ]),
            _vm._v(
              _vm._s(_vm.profil.pouzivatel_id.pouzivatel_xp) +
                " / " +
                _vm._s(
                  _vm.profil.pouzivatel_id.pouzivatel_next_level_threshold
                ) +
                "\n            "
            )
          ])
        ]
      ),
      _vm._v(" "),
      typeof _vm.show != "undefined"
        ? _c("div", { class: "m-userInfo__menu" + _vm.show }, [
            _c(
              "button",
              {
                staticClass: "a-userInfo__name dropdown-toggle",
                attrs: {
                  type: "button",
                  id: "dropdownMenuButton",
                  "data-toggle": "dropdown",
                  "aria-haspopup": "true",
                  "aria-expanded": _vm.aria
                },
                on: {
                  click: function($event) {
                    return _vm.dropdown()
                  }
                }
              },
              [
                _c("span", { staticClass: "d-none d-md-inline-block" }, [
                  _vm._v(_vm._s(_vm.profil.pouzivatel_id.pouzivatel_name))
                ]),
                _vm._v(" "),
                _c("span", {
                  staticClass: "d-inline-block d-md-none user__icon"
                })
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                class: "dropdown-menu" + _vm.show,
                attrs: {
                  "aria-labelledby": "dropdownMenuButton",
                  "x-placement": "bottom-start"
                }
              },
              [
                _c("div", { staticClass: "d-block d-lg-none userInfoMobile" }, [
                  _c("div", { staticClass: "a-userInfo__item" }, [
                    _c("span", { staticClass: "icon __coins" }),
                    _vm._v(
                      _vm._s(_vm.profil.pouzivatel_id.pouzivatel_wallet) +
                        "\n                    "
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "a-userInfo__item" }, [
                    _c("span", { staticClass: "icon __banknotes" }),
                    _vm._v(
                      _vm._s(_vm.profil.pouzivatel_id.pouzivatel_bankovky) +
                        "\n                    "
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "a-userInfo__item" }, [
                    _c("span", { staticClass: "icon __experience" }, [
                      _c("span", { staticClass: "level-number" }, [
                        _vm._v(_vm._s(_vm.profil.pouzivatel_id.level_id))
                      ])
                    ]),
                    _vm._v(
                      _vm._s(_vm.profil.pouzivatel_id.pouzivatel_xp) +
                        " / " +
                        _vm._s(
                          _vm.profil.pouzivatel_id
                            .pouzivatel_next_level_threshold
                        ) +
                        "\n                    "
                    )
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "router-link",
                  {
                    staticClass: "dropdown-item",
                    attrs: { to: { name: "profil" } }
                  },
                  [_vm._v("\n                    Môj profil\n                ")]
                ),
                _vm._v(" "),
                _c(
                  "router-link",
                  {
                    staticClass: "dropdown-item",
                    attrs: { to: { name: "kravicky" } }
                  },
                  [
                    _vm._v(
                      "\n                    Moje kravičky\n                "
                    )
                  ]
                ),
                _vm._v(" "),
                _vm.profil.pouzivatel_id.farma_pouzivatela.length != 0
                  ? _c(
                      "a",
                      {
                        staticClass: "dropdown-item",
                        attrs: {
                          href:
                            "https://www.adoptujkravicku.sk/hra/farma/moja-farma?" +
                            _vm.profil.pouzivatel_id.id +
                            "&" +
                            _vm.profil.pouzivatel_id.pouzivatel_name +
                            "&" +
                            _vm.profil.pouzivatel_email
                        }
                      },
                      [
                        _vm._v(
                          "\n                    Moja farma\n                "
                        )
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "router-link",
                  {
                    staticClass: "dropdown-item",
                    attrs: { to: { name: "aktivita" } }
                  },
                  [
                    _vm._v(
                      "\n                    Moja aktivita\n                "
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "router-link",
                  {
                    staticClass: "dropdown-item",
                    attrs: { to: { name: "album" } }
                  },
                  [_vm._v("\n                    Môj album\n                ")]
                ),
                _vm._v(" "),
                _c(
                  "router-link",
                  {
                    staticClass: "dropdown-item",
                    attrs: { to: { name: "statistiky" } }
                  },
                  [_vm._v("\n                    Štatistiky\n                ")]
                ),
                _vm._v(" "),
                _c(
                  "router-link",
                  {
                    staticClass: "dropdown-item",
                    attrs: { to: { name: "spravy" } }
                  },
                  [_vm._v("\n                    Správy\n                ")]
                ),
                _vm._v(" "),
                _c(
                  "router-link",
                  {
                    staticClass: "dropdown-item",
                    attrs: { to: { name: "heslo" } }
                  },
                  [
                    _vm._v(
                      "\n                    Zmena hesla\n                "
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "router-link",
                  {
                    staticClass: "dropdown-item",
                    attrs: { to: { name: "udaje" } }
                  },
                  [_vm._v("\n                    Moje údaje\n                ")]
                ),
                _vm._v(" "),
                _c(
                  "router-link",
                  {
                    staticClass: "dropdown-item",
                    attrs: { to: { name: "login", params: { reset: true } } }
                  },
                  [
                    _vm._v(
                      "\n                    Odhlásiť sa\n                "
                    )
                  ]
                )
              ],
              1
            )
          ])
        : _vm._e()
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "header__right d-flex" },
      [
        _c(
          "button",
          {
            class: "hamburger hamburger--elastic" + _vm.isActive,
            attrs: { type: "button" },
            on: {
              click: function($event) {
                return _vm.sidemenu()
              }
            }
          },
          [_vm._m(0)]
        ),
        _vm._v(" "),
        _c("menu-side", { attrs: { isActive: _vm.isActive } })
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "hamburger-box" }, [
      _c("span", { staticClass: "hamburger-inner" })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }